/**
 * @desc 查询可用库存
 */
const URL = "/rantion-stock";
import http, { updateResponse } from "@/http";
export function request(body: defs.stock.StockMatchingQry, options?: any) {
  return updateResponse(
    http(URL + `/stock/getStockUseQty`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
